/**
 * ktechs-panel-link: a row that opens its page in a panel over the product (7 Oct 2026).
 *
 * The category disclaimer row (Keycap Disclaimers, Switch Disclaimers) is a real link to its page.
 * A plain tap opens the page's text in a panel through the OverlayManager that runs the cart, the
 * search and the filters, so it gets the same dim, focus handling, Escape and back gesture, and the
 * customer stays exactly where they were on the product. A modified click, a middle click, a
 * right click, a search engine and a browser without scripts all still get the page itself.
 */
if (!customElements.get('ktechs-panel-link')) {
  class KtechsPanelLink extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a[href]');
      if (!this.link) return;
      this.onClick = (event) => {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const panel = document.getElementById(this.dataset.panel);
        if (!panel || typeof OverlayManager === 'undefined') return;
        event.preventDefault();
        OverlayManager.open(panel);
      };
      this.link.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.link && this.onClick) this.link.removeEventListener('click', this.onClick);
    }
  }
  customElements.define('ktechs-panel-link', KtechsPanelLink);
}
